export const Slider = {
	name: 'Slider',
	props: {
		arrows: {
			type: Boolean,
			default: true
		},
		dots: {
			type: String,
			default: '',
		},
		dotColor: {
			type: String,
			default: '',
		},
		title: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			numPages: 0,
			currPage: 1,
			sliderDots: [],
			sliderDot: [],
		};
	},
	watch: {
		currPage(newVal) {
			this.$emit('page-change', newVal-1);
		}
	},
	computed: {
		trackPos() {
			return `-${(this.currPage - 1) * 100}%`;
		},
	},
	beforeMount() {
		this.$on('update-data', (numPages, currPage) => {
			this.currPage = currPage;
			this.numPages = numPages;
			this.updated = true;
		});

	},
	mounted() {
		this.sliderDots = [
			'slider__dots',
			this.dots ? 'slider__dots--' + this.dots : '',
		]

		this.sliderDot = [
			'slider__dot',
			this.dotColor ? 'slider__dot--' + this.dotColor : ''
		]

		if (!this.updated) {
			console.warn(
				"The <Slider> info was not updated. May cause unexpected behavior.\n" +
				"Just $emit this custom-event: this.$parent.$emit('update-data',<numPages>, <currentPage>?);",
				this.$el
			);
		}
	},
	template: `
	<div class="slider">
		<h3 class="slider__title" v-if="title !== null">{{ title }}</h3>
		<div class="slider__body">
			<div :class="sliderDots" v-if="dots && numPages > 1">
					<div :class="[page == currPage ? 'is-active' : '', ...sliderDot ]" v-for="page in numPages" @click="currPage=page"></div>
			</div>
			<div class="slider__arrow slider__arrow--prev" @click="currPage--" :class="{ 'is-hidden' : currPage == 1 }" v-if="arrows"></div>
			<div class="slider__track">
				<div class="slider__mat" :style="{transform: 'translateX('+trackPos+')'}">
					<slot></slot>
				</div>
			</div>
			<div class="slider__arrow slider__arrow--next" @click="currPage++" :class="{ 'is-hidden' : currPage == numPages }" v-if="arrows"></div>
		</div>
	</div>`,
}
